import * as React from 'react';
import { memo } from 'react';
import { Spinner, Toast as BootstrapToast, ToastBody } from 'reactstrap';
import css from './Toasts.module.scss';
export var Toast = memo(function (_a) {
    var visible = _a.visible, toast = _a.toast;
    return (React.createElement(BootstrapToast, { isOpen: visible },
        React.createElement(ToastBody, { className: toast.pending ? css.pending : '' },
            toast.pending && React.createElement(Spinner, { className: css.spinner }),
            React.createElement("p", null, toast.text))));
});
export var Toasts = memo(function (_a) {
    var toasts = _a.toasts;
    return (React.createElement("div", { "aria-atomic": "true", "aria-live": "polite", className: "toast-container" },
        React.createElement("div", { className: "toast-container-inner" }, toasts.map(function (toast) { return (React.createElement(Toast, { key: toast.key, toast: toast, visible: toast.visible })); }))));
});
//# sourceMappingURL=Toasts.js.map